import grades from './SelectList/GradesCarabineros'

// Only existing nominal ranks may supply an exact value. Imported numeric
// references and CPR tariff labels are not hierarchical ranks.
const exactGrades = grades.filter(
  (grade) => grade !== 'Sin definir' && !grade.startsWith('C.P.R.')
)

export const partnerHierarchy = (partner = {}) => ({
  hierarchicalGroup: partner.hierarchicalGroup || '',
  hierarchicalGrade:
    partner.hierarchicalGrade !== undefined
      ? partner.hierarchicalGrade || ''
      : exactGrades.includes(partner.grade)
      ? partner.grade
      : ''
})

export const appendHierarchy = (formData, values) => {
  // GetFormData omits empty values; these fields must explicitly allow clearing.
  formData.set('hierarchicalGroup', values.hierarchicalGroup || '')
  formData.set('hierarchicalGrade', values.hierarchicalGrade || '')
}
